import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BasicAlertTitle, ClickIt } from "../../../../Constants/Constants";
import { BasicAlertSubTitle } from "../../../../Data/BonusUi/SweetAlert";

const BasicAlert = () => {
  const handleAlert = () => Swal.fire("Welcome! to the Moscow theme");
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={BasicAlertTitle} span={BasicAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="sweet-1" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicAlert;
